import type {
    StateCardEmptyMappingConstantType,
    StateCardEmptyMapping
} from "./type";
import {
    getEmptyType
} from "../empty/stylesheet";
import Button from "../button";
import Empty from "../empty";

export const getEmptyPropsFromStateCard = ({
    props
}: StateCardEmptyMappingConstantType): StateCardEmptyMapping => {
    const {
        isTransparentBackground = false,
        isLoading = false,
        isShowIcon = true,
        type = "neutral",
        size = "medium",
        icon: IconProp,
        subTitleStyle,
        titleStyle,
        iconSize,
        subTitle,
        action,
        title,
        ...rest
    } = props;

    const currentType = getEmptyType({
        type
    });

    const isTitleVisible = isLoading || !!title;

    const isSubTitleVisible = isLoading ? subTitle !== undefined : !!subTitle;

    const renderMedia = () => {
        if(!isShowIcon) {
            return null;
        }

        return <Empty.Media
            iconSize={iconSize}
            icon={IconProp}
        />;
    };

    const renderTitle = () => {
        if(!isTitleVisible) {
            return null;
        }

        return <Empty.Title
            style={titleStyle}
        >
            {title}
        </Empty.Title>;
    };

    const renderDescription = () => {
        if(!isSubTitleVisible) {
            return null;
        }

        return <Empty.Description
            style={subTitleStyle}
        >
            {subTitle}
        </Empty.Description>;
    };

    const renderHeader = () => {
        if(!isShowIcon && !isTitleVisible && !isSubTitleVisible) {
            return null;
        }

        return <Empty.Header>
            {renderMedia()}
            {renderTitle()}
            {renderDescription()}
        </Empty.Header>;
    };

    const renderContent = () => {
        if(!action) {
            return null;
        }

        return <Empty.Content>
            <Button
                variant={currentType.actionVariant}
                customTheme={rest.customTheme}
                spreadBehaviour="free"
                size={size}
                {...action}
                type={type}
            />
        </Empty.Content>;
    };

    return {
        emptyProps: {
            ...rest,
            variant: isTransparentBackground ? "plain" : "card",
            isLoading,
            type,
            size
        },
        children: <>
            {renderHeader()}
            {renderContent()}
        </>
    };
};
